import { Component } from "react";
import { withRouter } from "react-router-dom";
import { signOut } from "@culturehq/client";

import { errorService, t } from "app/utils";

const TIMEOUT = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

class SessionTimeout extends Component {
  componentDidMount() {
    this.lastActionAt = new Date();

    window.addEventListener("touchstart", this.handleActionTaken);
    window.addEventListener("click", this.handleActionTaken);
    window.addEventListener("keypress", this.handleActionTaken);
  }

  componentWillUnmount() {
    window.removeEventListener("touchstart", this.handleActionTaken);
    window.removeEventListener("click", this.handleActionTaken);
    window.removeEventListener("keypress", this.handleActionTaken);
  }

  handleActionTaken = async () => {
    const actionAt = new Date();

    if ((actionAt - this.lastActionAt) < TIMEOUT) {
      this.lastActionAt = actionAt;
      return;
    }

    await signOut();
    this.lastActionAt = new Date();

    // eslint-disable-next-line no-alert
    window.alert(t("Your session has expired."));

    const { history } = this.props;
    errorService.log("Redirect to login, session timeout");
    history.push("/login");
  };

  render() {
    return null;
  }
}

export default withRouter(SessionTimeout);
